(() => {
  const drawer = document.querySelector('[data-runix-drawer]');
  const opener = document.querySelector('[data-runix-menu-open]');
  const desktopGroups = [...document.querySelectorAll('.runix-desktop-nav .runix-nav-group')];

  desktopGroups.forEach((group) => {
    let closeTimer;
    const openGroup = () => {
      clearTimeout(closeTimer);
      desktopGroups.forEach((item) => {
        if (item !== group) item.removeAttribute('open');
      });
      group.setAttribute('open', '');
    };
    const queueClose = () => {
      closeTimer = window.setTimeout(() => group.removeAttribute('open'), 130);
    };

    group.addEventListener('pointerenter', openGroup);
    group.addEventListener('pointerleave', queueClose);
    group.addEventListener('focusin', openGroup);
    group.querySelector('summary').addEventListener('click', (event) => {
      event.preventDefault();
      openGroup();
    });
    group.addEventListener('focusout', (event) => {
      if (!group.contains(event.relatedTarget)) queueClose();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') desktopGroups.forEach((group) => group.removeAttribute('open'));
  });

  if (!drawer || !opener) return;
  const panel = drawer.querySelector('[data-runix-drawer-panel]');
  const closer = drawer.querySelector('[data-runix-menu-close]');
  let previousFocus;

  const open = () => {
    previousFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('runix-menu-open');
    closer?.focus();
  };
  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('runix-menu-open');
    previousFocus?.focus();
  };

  opener.addEventListener('click', open);
  closer?.addEventListener('click', close);
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  panel?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a,button,input,select,summary')].filter((item) => !item.disabled);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
